"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServerChatbotEvent = exports.ServerChatbotEvent = void 0;
var ServerChatbotEvent;
(function (ServerChatbotEvent) {
    ServerChatbotEvent["createFeedback"] = "createFeedback";
    ServerChatbotEvent["createReservation"] = "createReservation";
    ServerChatbotEvent["getAddress"] = "getAddress";
    ServerChatbotEvent["getAvailableLayoutTypes"] = "getAvailableLayoutTypes";
    ServerChatbotEvent["getDatetimeRestriction"] = "getDatetimeRestriction";
    ServerChatbotEvent["getFacebookPage"] = "getFacebookPage";
    ServerChatbotEvent["getFaqAnswers"] = "getFaqAnswers";
    ServerChatbotEvent["getHours"] = "getHours";
    ServerChatbotEvent["getPhoneNumber"] = "getPhoneNumber";
    ServerChatbotEvent["getPlaceMenu"] = "getPlaceMenu";
    ServerChatbotEvent["getReservationRestriction"] = "getReservationRestriction";
})(ServerChatbotEvent || (exports.ServerChatbotEvent = ServerChatbotEvent = {}));
const serverChatbotEventSet = new Set(Object.values(ServerChatbotEvent));
const isServerChatbotEvent = (event) => serverChatbotEventSet.has(event);
exports.isServerChatbotEvent = isServerChatbotEvent;
//# sourceMappingURL=ServerChatbotEvent.js.map